
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelAddress from "@/views/审核管理/model/DZModelAddress";
import nyNetwork from "@/api/nyBaseNetwork";
import nyMessageToast from "@/utils/NYMessageToast";
import DZServiceCourtship from "@/views/审核管理/service/DZServiceCourtship";
import AMapLoader from "@amap/amap-jsapi-loader";

@Component
export default class Address extends Vue{

  rules = {
    countyArr:[{ required: true, message: '请选择地区', trigger: 'blur' }],
    addressInfo:[{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  }

  @Prop() data;
  @Prop() sign;
  m_address = new DZModelAddress();

  flag = true

  serve = new DZServiceCourtship();

  dialogVisible = false

  openMap(){
    this.dialogVisible = true
    this.initAMap()
  }

  closeMap(){
    this.dialogVisible = false
  }

  created() { }

  mounted() {

  }

  @Watch("data")
  watchData(value: any, oldValue: string) {
    if(value){
      this.m_address = value;
      let arr = [value.provinceId,value.cityId,value.countyId]
      this.m_address.countyArr = JSON.parse(JSON.stringify(arr))
      console.log(this.m_address.countyArr)
    }
  }
  handle_edit(){
    this.flag = !this.flag
  }

  handle_submit(){
    // @ts-ignore
    this.$refs.addressForm.validate(v=>{
      if(v){
        // @ts-ignore
        const checked = this.$refs.cas.getCheckedNodes()[0];
        const labels = checked.pathLabels
        const ids = this.m_address.countyArr
        this.m_address.provinceName = labels[0]
        this.m_address.cityName = labels[1]
        this.m_address.countyName = labels[2]
        this.m_address.provinceId = ids[0]
        this.m_address.cityId = ids[1]
        this.m_address.countyId = ids[2]
        this.$emit('ny_submit', this.m_address)
        this.handle_edit()
      }else {
        nyMessageToast.warning("请输入必填项")
        return false
      }
    })
  }

  el_cascader_props = {
    lazy: true,
    lazyLoad (node, resolve) {
      const { level,value } = node;
      let id = 0
      if(level != 0){
        id = value
      }
      nyNetwork.net("城市子列表",{pid:id}, data => {
        const nodes = data.map(i=>{
          return {
            value:i.id,
            label:i.name,
            leaf:level>=2
          }
        })
        resolve(nodes)
      })
    }
  }

  map = {}

  lng = '';
  lat = '';

  placeSearch = {}

  clickHandler(e) {
    this.lng = e.lnglat.getLng()
    this.lat = e.lnglat.getLat()
  };

  initAMap() {
    let that = this
    AMapLoader.load({
      key: "7ee596b0538e7dc8a1e29ade483c1338",
      //@ts-ignore
      securityKey :'e19ff4b13855ad589b867e2e7997b0c8',
      version: "2.0",
      plugins: ["AMap.Scale","AMap.PlaceSearch","AMap.AutoComplete"],
    })
    .then((AMap) => {
      this.map = new AMap.Map("mapContainer", {zoom: 11, center: [116.397428, 39.90923], resizeEnable: true})
      //@ts-ignore
      this.map.on('click',this.clickHandler)
      AMap.plugin(['AMap.PlaceSearch','AMap.AutoComplete'], function(){
        console.log(123)
        var auto = new AMap.AutoComplete({
          input: "map_search"
        });
        var placeSearch = new AMap.PlaceSearch({
          map: that.map
        });
        auto.on("select", select);
        function select(e) {
          console.log(e)
          placeSearch.setCity(e.poi.adcode);
          placeSearch.search(e.poi.name);
        }
      });
    })
    .catch((e) => {
      console.log(e);
    });
  }

  chooseZB(){
    this.m_address.lng = this.lng
    this.m_address.lat = this.lat
    this.dialogVisible = false
  }
}
